<template>
  <div id="upload-demo">
    <div class="vx-col w-full">
      <vx-card  title="Customer Wise Product List Report">
        <template slot="actions">
          <div class="demo-alignment">
<!--            <datepicker class="mt-0 mb-5" name="start_date" :format="formatedDate(searchParam.date_from)" v-validate="'required'" placeholder="Select Date" v-model="searchParam.date_from"/>
            <datepicker class="mt-0 mb-5" name="end_date" :format="formatedDate(searchParam.date_to)" v-validate="'required'" placeholder="Select Date" v-model="searchParam.date_to"/>-->
            <vs-input class="mt-0 mb-5" placeholder="Nid No" @keypress="onlyNumber" v-model="nid"/>
            <vs-button class="mt-0 mb-5" color="rgb(0 121 193)"  icon-pack="feather" icon="icon-eye" @click="showReport(nid)" :disabled="!nid">Show Report</vs-button>
            <vs-button class="mt-0 mb-5" color="rgb(0 121 193)"  icon-pack="feather" icon="icon-arrow-down" @click="download(nid)" :disabled="!nid">Download Report</vs-button>
          </div>
        </template>
        <template>
          <vs-table
            :sst="true"
            :data="dataList">

            <template slot="thead">
              <vs-th sort-key="ID">
                Name
              </vs-th>
              <vs-th sort-key="ID">
                Mobile
              </vs-th>
              <vs-th sort-key="ID">
                Suffix
              </vs-th>

              <vs-th sort-key="ID">
                Date
              </vs-th>
              <vs-th sort-key="email">
                Article
              </vs-th>
              <vs-th sort-key="username">
                Description
              </vs-th>

              <vs-th sort-key="website">
                Agreement number
              </vs-th>
              <vs-th sort-key="id">
                Invoice number
              </vs-th>

            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].user.ekyc.parsonal">
                  {{data[indextr].user.ekyc.parsonal.name +' '+ data[indextr].user.ekyc.parsonal.last_name}}
                </vs-td>
                <vs-td :data="data[indextr].user.ekyc">
                  {{data[indextr].user.ekyc.phone}}
                </vs-td>
                <vs-td :data="data[indextr].showroom.suffix">
                  {{data[indextr].showroom.suffix}}
                </vs-td>

                <vs-td :data="data[indextr].accepting_date">
                  {{data[indextr].accepting_date}}
                </vs-td>

                <vs-td :data="data[indextr].product_master.article">
                  {{data[indextr].product_master.article}}
                </vs-td>

                <vs-td :data="data[indextr].product_master.article_description">
                  {{data[indextr].product_master.article_description}}
                </vs-td>

                <vs-td :data="data[indextr].id">
                  {{paddingId(data[indextr].id)}}
                </vs-td>

                <vs-td :data="data[indextr].invoice_number">
                  {{data[indextr].invoice_number}}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </template>
      </vx-card>
    </div>

  </div>

</template>

<script>
  import {mapGetters} from "vuex";
  import moment from "moment";
  import Datepicker from 'vuejs-datepicker'
  import { ME } from '../graphql/userinfo'
  import axios from '../axios'

  export default {
    data() {
      return {
        userInfo: {
          ekyc:{
            status:''
          }
        },
        nid:'',
        dataList:[]
      }
    },
    apollo: {
      user: {
        query: ME,
        manual: true,
        result ({ data, loading }) {
          if (!loading) {
            this.userInfo = data.me
          }
        }
      }
    },
    computed: {
      ...mapGetters(['meta']),
      activeUserInfo () {
        return this.$store.state.AppActiveUser
      }
    },
    mounted () {

    },
    methods: {
      /*formatedDate(date) {
        return moment(date).format('yyyy-MM-DD');
      },*/
      showReport(param){
        this.$vs.loading({
          type: 'sound'
        })
        axios({
          url: 'https://ho.butterflygroupbd.com/showroom-backend/api/showroomWiseCustomerReportPreview',
          //url: 'https://ho.butterflygroupbd.com/showroom-backend/api/showroomWiseCustomerReportPreview',
          data:{ showroomId: this.userInfo.id, nid: param},
          method: 'POST',
          //responseType: 'blob', // important for excel download

        }).then((response) => {
          if(response.status !== 201){
            this.dataList = response.data;
            this.$vs.loading.close();
          }else {
            this.$vs.notify({
              title: 'No Data found!',
              text: 'No Data found with this nid '+param,
              color: 'warning',
              position: 'top-right'
            });
          }

        }).catch((error) => {
          this.$vs.notify({
            title: 'No Data found!',
            text: 'No Data found with this nid '+param,
            color: 'warning',
            position: 'top-right'
          });
          this.$vs.loading.close();
        });

      },
      download(param){
        this.$vs.loading({
          type: 'sound'
        })
        axios({
          url: 'https://ho.butterflygroupbd.com/showroom-backend/api/showroomWiseCustomerReport',
          //url: 'https://ho.butterflygroupbd.com/showroom-backend/api/showroomWiseCustomerReport',
          data:{ showroomId: this.userInfo.id, nid: param},
          method: 'POST',
          responseType: 'blob', // important for excel download

        }).then((response) => {
          if(response.status !== 201){
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'product_list.xlsx');
            document.body.appendChild(link);
            link.click();
            this.$vs.loading.close();
          }else {
            this.$vs.notify({
              title: 'No Data found!',
              text: 'No Data found with this nid '+param,
              color: 'warning',
              position: 'top-right'
            });
          }

        }).catch((error) => {
          this.$vs.notify({
            title: 'No Data found!',
            text: 'No Data found with this nid '+param,
            color: 'warning',
            position: 'top-right'
          });
          this.$vs.loading.close();
        });

      },
      paddingId(id){
        if(id.toString().length === 1){return 'A000000000'+id;}
        else if(id.toString().length === 2){return 'A00000000'+id;}
        else if(id.toString().length === 3){return 'A0000000'+id;}
        else if(id.toString().length === 4){return 'A000000'+id;}
        else if(id.toString().length === 5){return 'A00000'+id;}
        else if(id.toString().length === 6){return 'A0000'+id;}
        else if(id.toString().length === 7){return 'A000'+id;}
        else if(id.toString().length === 8){return 'A00'+id;}
        else if(id.toString().length === 9){return 'A'+id;}
        else if(id.toString().length === 10){return id;}

      },
      onlyNumber($event) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
          $event.preventDefault()
        }
      },
    },
    components: {
      Datepicker
    }
  }
</script>
<style scoped>
  .mismatch{
    background-color: #ea5455;
    font-weight: 700;
    color: #fff;
  }
  .match {
    background-color: #28c76f;
  }
  table.vs-table.vs-table--tbody-table tr {
    border-bottom: 1px solid #f8f8f8;
  }
</style>
